import { defineComponent as e } from "vue";
import t from "../spinner/Spinner.vue.js";
import "./ApIndicator.css";
const s = e({
  components: { Spinner: t },
  props: {
    spinnerType: { default: "Snake" },
    text: { type: String }
  },
  data() {
    return {
      visible: !1
    };
  },
  computed: {
    convertedSpinnerType() {
      switch (this.spinnerType) {
        case "DoubleBounce":
          return 1;
        case "TripleBounce":
          return 2;
        case "FadingCircle":
          return 3;
        default:
          return 0;
      }
    }
  },
  methods: {
    show() {
      this.visible = !0;
    },
    hide() {
      this.visible = !1;
    }
  }
});
export {
  s as default
};
